/*
document.addEventListener("DOMContentLoaded", function () {
    console.log('aa');

    setTimeout(function () {
        console.log('bb');

        var buttons = document.querySelectorAll(".ES-button-CPR");

        console.log('cc');
        console.log(buttons);

        for (var i = 0; i < buttons.length; i++) {
        console.log('zz');
            buttons[i].addEventListener("click", function () {
                console.log('dd');

                var drawer = document.querySelector("cart-drawer");
                if (drawer && drawer.renderContents) {
                    drawer.renderContents();
                }
            });
        }

    }, 3000);
});
*/
/*
document.addEventListener("DOMContentLoaded", function () {

    setTimeout(function () {
    document.addEventListener("click", function (e) {
        var target = e.target.closest(".ES-button-CPR");
        if (!target) return;

        console.log("CLICK CAPTURE Chrome OK");

        var drawer = document.querySelector("cart-drawer");
        if (drawer && drawer.renderContents) drawer.renderContents();
    }, true); // ← IMPORTANT : PHASE DE CAPTURE

    }, 3000);
}); */
/**
 * Rafraîchit la barre de progression #CartDrawer-progress
 * en re-fetchant la section cart-drawer depuis Shopify.
 */
function ldsRefreshProgressBar() {
  fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
    .then(function (response) { return response.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newProgress = doc.getElementById('CartDrawer-progress');
      var currentProgress = document.getElementById('CartDrawer-progress');
      if (newProgress && currentProgress) {
        currentProgress.outerHTML = newProgress.outerHTML;
      }
    });
}

/**
 * Intercepte les appels fetch vers les endpoints du panier Shopify
 * pour déclencher le rafraîchissement de la barre de progression.
 */
(function () {
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var result = originalFetch.apply(this, args);

    if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
      result.then(function (response) {
        if (response.ok) {
          ldsRefreshProgressBar();
        }
        return response;
      });
    }

    return result;
  };
})();